var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAdjusts = function SvgAdjusts(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.57143 1H16.4286C17.8531 1 19 2.14686 19 3.57143V16.4286C19 17.8531 17.8531 19 16.4286 19H3.57143C2.14686 19 1 17.8531 1 16.4286V3.57143C1 2.14686 2.14686 1 3.57143 1Z",
    stroke: "#4A4E55",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.85712 4.85693H6.14283",
    stroke: "#4A4E55",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71429 4.85707L15.1429 4.85693",
    stroke: "#4A4E55",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1428 10H13.8571",
    stroke: "#4A4E55",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2857 10.0001L4.85712 10",
    stroke: "#4A4E55",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.85712 15.1431H6.14283",
    stroke: "#4A4E55",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71429 15.1432L15.1429 15.1431",
    stroke: "#4A4E55",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42858 16.4289C7.08759 16.4289 6.76056 16.2934 6.51944 16.0523C6.27832 15.8112 6.14287 15.4841 6.14287 15.1431C6.14287 14.8021 6.27832 14.4751 6.51944 14.234C6.76056 13.9929 7.08759 13.8574 7.42858 13.8574C7.59742 13.8574 7.76461 13.8907 7.9206 13.9553C8.07659 14.0199 8.21833 14.1146 8.33772 14.234C8.45711 14.3534 8.55181 14.4951 8.61642 14.6511C8.68104 14.8071 8.71429 14.9743 8.71429 15.1431C8.71429 15.312 8.68104 15.4792 8.61642 15.6352C8.55181 15.7911 8.45711 15.9329 8.33772 16.0523C8.21833 16.1717 8.07659 16.2664 7.9206 16.331C7.76461 16.3956 7.59742 16.4289 7.42858 16.4289Z",
    stroke: "#4A4E55",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5714 11.2858C12.9124 11.2858 13.2394 11.1503 13.4806 10.9092C13.7217 10.6681 13.8571 10.3411 13.8571 10.0001C13.8571 9.65908 13.7217 9.33205 13.4806 9.09093C13.2394 8.84981 12.9124 8.71436 12.5714 8.71436C12.2304 8.71436 11.9034 8.84981 11.6623 9.09093C11.4212 9.33205 11.2857 9.65908 11.2857 10.0001C11.2857 10.3411 11.4212 10.6681 11.6623 10.9092C11.9034 11.1503 12.2304 11.2858 12.5714 11.2858Z",
    stroke: "#4A4E55",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.42858 6.14272C7.08759 6.14272 6.76056 6.00726 6.51944 5.76614C6.27832 5.52502 6.14287 5.198 6.14287 4.857C6.14287 4.51601 6.27832 4.18898 6.51944 3.94787C6.76056 3.70675 7.08759 3.57129 7.42858 3.57129C7.59742 3.57129 7.76461 3.60454 7.9206 3.66916C8.07659 3.73377 8.21833 3.82848 8.33772 3.94787C8.45711 4.06726 8.55181 4.20899 8.61642 4.36498C8.68104 4.52097 8.71429 4.68816 8.71429 4.857C8.71429 5.02585 8.68104 5.19303 8.61642 5.34902C8.55181 5.50501 8.45711 5.64675 8.33772 5.76614C8.21833 5.88553 8.07659 5.98023 7.9206 6.04485C7.76461 6.10946 7.59742 6.14272 7.42858 6.14272Z",
    stroke: "#4A4E55",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAdjusts);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Adjusts.24327f51a398067d9b31e7735999bfbf.svg";